import React, { useMemo, useState } from "react";
import { Modal } from "../Modal";

import { getValue } from "../../utils/object.utils";

import { useDispatch } from "react-redux";
import {
  setErrorMessage,
  setSuccessMessage,
  setWarningMessage,
} from "../../Redux/Slices/alert.slice";
import { parseApiError } from "../../Helper/apiError.helper";
import { ClassForm } from "./ClassForm";
import { useUpdateClass } from "../../hooks/classHooks/class.hooks";

interface Props {
  selectedClass: any;
  open: boolean;
  onClose: () => unknown;
}
export const EditClassModal = ({ selectedClass, open, onClose }: Props) => {
  const dispatch = useDispatch();

  const [className, setClassName] = useState("");

  const { isLoading: isUpdatingClass, mutate: updateClass } = useUpdateClass({
    onSuccess: () => {
      dispatch(setSuccessMessage("Class updated successfully."));
      onClose();
    },
    onError: (error: Error) => {
      dispatch(setErrorMessage(parseApiError(error)));
    },
  });

  const handleClassUpdate = () => {
    if (!className) {
      return dispatch(setWarningMessage("Please enter class name"));
    }

    const classId = getValue(selectedClass, "id");

    if (!classId) return null;

    updateClass({
      classId,
      body: {
        className,
      },
    });
  };

  useMemo(() => {
    const className = getValue(selectedClass, "name", "");

    setClassName(className);
  }, [selectedClass]);

  return (
    <Modal
      show={open}
      onClose={onClose}
      modalHeader="Edit block"
      submissionButton={{
        text: "Save",
        onClick: () => {
          handleClassUpdate();
        },
        isSubmitLoading: isUpdatingClass,
      }}
    >
      <ClassForm className={className} setClassName={setClassName} />
    </Modal>
  );
};
